// extracted by mini-css-extract-plugin
export var voiceConversionContent = "_h7-0";